const Ua = () => {
  const userAgent = window.navigator.userAgent.toUpperCase();
  if (!(userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1)) {
    // It's IE
    document.body.classList.add('is-ie');
  }
}

export default Ua;


// WEBPACK FOOTER //
// ./src/recruit/js/ua.js